module.exports = __webpack_public_path__ + "static/media/drag.3e2cde9f.mp4";